// ── Token & Auth Data ────────────────────────────────────────────
export const getAuthToken = () => localStorage?.getItem("auth_token");

export const getUserData = () => {
    try {
        const raw = localStorage.getItem("user");
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const getFPOData = () => {
    try {
        const raw = localStorage.getItem("fpo");
        if (!raw) return null;
        return JSON.parse(raw);
    } catch {
        return null;
    }
};

export const getUserId       = () => getUserData()?.id;
export const getUserRole     = () => getUserData()?.role ?? "";
export const getUserName     = () => getUserData()?.username ?? "";
export const getUserFullName = () => {
    const u = getUserData();
    if (!u) return "";
    return `${u.first_name ?? ""} ${u.last_name ?? ""}`.trim();
};

export const getFPOName     = () => getFPOData()?.name ?? "";
export const getFPORegNo    = () => getFPOData()?.registration_no ?? "";

// ── Auth Guard ───────────────────────────────────────────────────
export const isLoggedIn = () => {
    const token = getAuthToken();
    return !!(token && token.length > 5);
};

// ── Persist Login ────────────────────────────────────────────────
export const persistLogin = ({ token, user, fpo, role, designation }) => {
    localStorage.setItem("auth_token", token);
    localStorage.setItem("user", JSON.stringify({ ...user, role, designation }));
    localStorage.setItem("fpo", JSON.stringify(fpo));
};

// ── Clear Session ────────────────────────────────────────────────
export const clearSession = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("user");
    localStorage.removeItem("fpo");
    localStorage.removeItem("sidebar_is_open");
};
